import { useMemo } from 'react';
export var useCommonDatePickerCompatibility = function useCommonDatePickerCompatibility(_ref) {
  var enableApplyButton = _ref.enableApplyButton,
    enableActionButtons = _ref.enableActionButtons;
  return useMemo(function () {
    return {
      enableApplyButton: !!(enableActionButtons !== undefined ? enableActionButtons : enableApplyButton)
    };
  }, [enableActionButtons, enableApplyButton]);
};